import React, { useEffect, useState } from "react"
import { Modal, Button, Tabs, message, notification } from "antd"
import { backButton } from "@telegram-apps/sdk-react"
import { useAppDispatch, useAppSelector } from "@/redux/provider"
import { AppActions, AppTypes } from "@/redux/app"
import { unlockPig } from "@/services/api"
import * as style from "./style.module.scss"
import { AccountActions } from "@/redux/account"

const ModalBoost = () => {
  const dispatch = useAppDispatch()
  const remoteModel = useAppSelector((state) => state.account.remoteModel)
  const modalUnlock = useAppSelector((state) => state.app.modalUnlock)
  const launchParams = useAppSelector((state) => state.app.launchParams)
  const pigToUnlock = remoteModel?.pigz[modalUnlock.id!]
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (modalUnlock.opened) {
      backButton.mount()
      backButton.show()
      return backButton.onClick(closeModal)
    }
    backButton.hide()
  }, [modalUnlock.opened])

  const closeModal = () => {
    dispatch(AppActions.MODAL_UNLOCK_SET(false, modalUnlock.id))
  }

  const unlock = async () => {
    setLoading(true)
    const result = await unlockPig(launchParams?.initDataRaw!, pigToUnlock?.id!)
    dispatch(AccountActions.ACCOUNT_INFO_UPDATE_SAGA())
    setTimeout(() => {
      if (result.error) {
        message.error("Unlock failed. Try again.")
      } else {
        message.success("Pig unlocked!")
      }
      setLoading(false)
      closeModal()
    }, 1000)
  }

  return (
    <Modal
      title={null}
      open={modalUnlock.opened}
      onCancel={() => closeModal()}
      footer={null}
      width={420}
      closeIcon={<span className="xi xi-close" />}
      destroyOnClose
    >
      <Tabs items={[{ key: "account", label: "Unlock Character" }]} />
      {pigToUnlock && (
        <div className="text-center">
          <h2 className="mb-0">{pigToUnlock?.name}</h2>
          <p className="text-muted mb-3">He's a good pig</p>
          <div className={style.character}>
            <img src={`/pigz/base/${pigToUnlock.id}/item/0.svg`} className={style.pic} />
            <img src={`/pigz/base/${pigToUnlock.id}/head/0.svg`} className={style.pic} />
            <img src={`/pigz/base/${pigToUnlock.id}/body/0.svg`} className={style.pic} />
            <img src={`/pigz/base/${pigToUnlock.id}/legs/0.svg`} className={style.pic} />
          </div>
          <div className="mb-2">
            <Button loading={loading} size="large" type="primary" onClick={() => unlock()}>
              <i className="xi xi-unlock" /> Unlock
            </Button>
          </div>
          <p className="text-muted font-size-14 mb-5">
            1 XDIAMOND will be spent
            <br />
            Balance: {remoteModel?.xdiamond || 0} XDIAMOND
          </p>
        </div>
      )}
    </Modal>
  )
}

export default ModalBoost
